import * as React from "react";
import { lang } from "../../lang";
import { CenteredContent } from "../../components/atoms/CenteredContent";
import { Title } from "../../components/atoms/Text";
import { Template } from "../../components/organisms/Template";

class NotFoundPage extends React.Component {
    public render(): React.ReactElement {
        return (
            <Template>
                <CenteredContent>
                    <Title>{lang.notFound}</Title>
                </CenteredContent>
            </Template>
        );
    }
}

export { NotFoundPage };
